import { LiveLikeWidgetElement } from "@livelike/engagementsdk";
const html = (window as any).html;

class SBSCheerOption extends LiveLikeWidgetElement {
  createRenderRoot(): this {
    return this;
  }
  votePercentage = () => {
    const totalVotes = this.items.reduce(
      (a: number, b: any) => a + b["vote_count"],
      0
    );
    return totalVotes > 0
      ? Math.round((this.item.vote_count / totalVotes) * 100)
      : 0;
  };
  optionVoteUpdated = () => {
    const imageContainer = this.shadowRoot?.querySelector("livelike-image");
    imageContainer &&
      imageContainer.style.setProperty(
        "background",
        `linear-gradient(0deg, #1ebf00 ${this.votePercentage()}%, transparent 0)`
      );
  };
  render() {
    const pct = this.votePercentage();
    return html`
      <div class="cheer-image-container">
        <div class="cheer-image-fill" style="height: ${pct}%"></div>
        <livelike-image></livelike-image>
      </div>
      <livelike-description></livelike-description>
    `;
  }
}
customElements.define("sbs-cheer-option", SBSCheerOption as any);
